import { render, staticRenderFns } from "./footerx.vue?vue&type=template&id=245a269c&"
import script from "./footerx.vue?vue&type=script&lang=js&"
export * from "./footerx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports